export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/app_website_previews.4339508.svg";